import React from "react"
import { Routes, Route, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FilePenLine, Building2, Wrench, Icon, Boxes, FileChartLine, FileBox, BriefcaseBusiness, TrendingUp, Activity, LayoutGrid, Warehouse, MapPin, BarChart3 } from 'lucide-react';
import { houses, toolbox } from '@lucide/lab';
import Inicio from "./pages/admin/Inicio";
import AAFF from "./pages/admin/AAFF";
import Comunidades from "./pages/admin/Comunidades";
import Comunidad from "./pages/admin/Comunidad";
import Proveedores from "./pages/admin/Proveedores";
import Proveedor from "./pages/admin/Proveedor";
import ProveedoresFincas from "./pages/admin/ProveedoresFincas";
import ProveedoresLista from "./pages/admin/ProveedoresLista";
import ProveedorDatos from "./pages/admin/ProveedorDatos";
import Ventas from "./pages/admin/Ventas";
import GestionComunidades from "./pages/admin/GestionComunidades";
import DatosPerfil from "../components/perfil/datosPerfil";

export function RouteBundle() {
  return (
    <Routes>
      <Route path="/" element={<Inicio />} />
      <Route path="/aaff" element={<AAFF />} />
      <Route path="/aaff/:nif/comunidades" element={<Comunidades />} />
      <Route path="/aaff/:nif/comunidades/:nifFinca" element={<Comunidad />} />
      <Route path="/aaff/:nif/proveedores" element={<Proveedores />} />
      <Route path="/aaff/:nifAAFF/proveedores/:nifProveedor" element={<Proveedor />} />
      <Route path="/aaff/:nifAAFF/comunidades/:nifFinca/proveedores" element={<ProveedoresFincas />} />
      <Route path="/proveedores" element={<ProveedoresLista />} />
      <Route path="/proveedores/:nifProveedor" element={<ProveedorDatos />} />
      <Route path="/servicios" element={<Ventas />} />
      <Route path="/comunidades" element={<GestionComunidades />} />
      <Route path="/perfil" element={<DatosPerfil />} />
    </Routes>
  )
}

const refrescoLocal = () => {
    // localStorage.setItem("hasReloaded", "true"); 
}


export function MenuLinksClientes(props) {
  const { t } = useTranslation('nav');
  return (
    <>
        <li>
          <NavLink activeclassname="active" to="/aaff" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "",  color: props.showSidebar ? "#33383b" : "#fff"}}>
            <div className="menuBtn" >
              <Building2 stroke-width="1.5" alt={t('clients.aaff')} />{t('clients.aaff')}
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink activeclassname="active" to="/comunidades" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn"  >
              <Icon iconNode={houses} stroke-width="1.5" alt={t('clients.communities')} />{t('clients.communities')}
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink activeclassname="active" to="/servicios" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn width=35px" >
              <Boxes stroke-width="1.5" width="35px" alt={t('clients.services')} />{t('clients.services')}
            </div>
          </NavLink>
        </li>
    </>
  )
}